module.exports = {
	"permanent": "Permanente",
	"buttons": {
		"cancel": "Cancelar",
		"close": "Fechar",
		"copy": "Copiar",
		"copyFile": "Copiar ficheiro",
		"copyToClipboard": "Copiar",
		"create": "Criar",
		"delete": "Eliminar",
		"download": "Descarregar",
		"info": "Info",
		"more": "Mais",
		"move": "Mover",
		"moveFile": "Mover ficheiro",
		"new": "Novo",
		"next": "Próximo",
		"ok": "OK",
		"previous": "Anterior",
		"publish": "Publicar",
		"rename": "Renomear",
		"replace": "Substituir",
		"reportIssue": "Reportar Erro",
		"save": "Guardar",
		"share": "Partilhar",
		"schedule": "Agendar",
		"search": "Pesquisar",
		"select": "Selecionar",
		"selectMultiple": "Selecionar múltiplos",
		"switchView": "Alterar modo de visão",
		"toggleSidebar": "Alternar barra lateral",
		"update": "Atualizar",
		"upload": "Enviar",
		"permalink": "Obter link permanente"
	},
	"success": {
		"linkCopied": "Link copiado!"
	},
	"errors": {
		"forbidden": "Tu não és bem-vindo aqui.",
		"internal": "Algo correu bastante mal.",
		"notFound": "Não conseguimos chegar a esta localização."
	},
	"files": {
		"body": "Corpo",
		"clear": "Limpar",
		"closePreview": "Fechar pré-visualização",
		"files": "Ficheiros",
		"folders": "Pastas",
		"home": "Início",
		"lastModified": "Última modificação",
		"loading": "A carregar...",
		"lonely": "Sinto-me sozinho...",
		"metadata": "Metadados",
		"multipleSelectionEnabled": "Seleção múltipla ativada",
		"name": "Nome",
		"size": "Tamanho",
		"sortByLastModified": "Ordenar pela última modificação",
		"sortByName": "Ordenar pelo nome",
		"sortBySize": "Ordenar pelo tamanho"
	},
	"help": {
		"click": "selecionar pasta ou ficheiro",
		"ctrl": {
			"click": "selecionar várias pastas e ficheiros",
			"f": "pesquisar",
			"s": "guardar um ficheiro ou descarregar a pasta em que estás a navegar"
		},
		"del": "eliminar os ficheiros selecionados",
		"doubleClick": "abrir pasta ou ficheiro",
		"esc": "limpar seleção e/ou fechar menu",
		"f1": "esta informação",
		"f2": "renomear ficheiro",
		"help": "Ajuda"
	},
	"languages": {
		"ar": "العربية",
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"ru": "Русский",
		"pl": "Polski"
	},
	"login": {
		"password": "Palavra-passe",
		"submit": "Login",
		"username": "Nome de utilizador",
		"wrongCredentials": "Dados errados"
	},
	"prompts": {
		"copy": "Copiar",
		"copyMessage": "Escolhe um lugar para copiar os ficheiros:",
		"currentlyNavigating": "A navegar em:",
		"deleteMessageMultiple": "Deseja eliminar {count} ficheiro(s)?",
		"deleteMessageSingle": "Deseja eliminar esta pasta/ficheiro?",
		"deleteTitle": "Eliminar ficheiros",
		"displayName": "Nome:",
		"download": "Descarregar ficheiros",
		"downloadMessage": "Escolha o formato do ficheiro.",
		"error": "Algo correu mal",
		"fileInfo": "Informação do ficheiro",
		"filesSelected": "{count} ficheiros selecionados.",
		"lastModified": "Última Modificação",
		"move": "Mover",
		"moveMessage": "Escolha uma nova casa para os seus ficheiros:",
		"newArchetype": "Criar um novo post baseado num \"archetype\". O seu ficheiro será criado na pasta \"content\".",
		"newDir": "Nova pasta",
		"newDirMessage": "Escreva o nome da nova pasta.",
		"newFile": "Novo ficheiro",
		"newFileMessage": "Escreva o nome do novo ficheiro.",
		"numberDirs": "Número de pastas",
		"numberFiles": "Número de ficheiros",
		"rename": "Renomear",
		"renameMessage": "Insira um novo nome para",
		"replace": "Substituir",
		"replaceMessage": "Já existe um ficheiro com nome igual a um dos que está a tentar enviar. Deseja substituir?\n",
		"schedule": "Agendar",
		"scheduleMessage": "Escolha uma data para publicar este post.",
		"show": "Mostrar",
		"size": "Tamanho"
	},
	"search": {
		"images": "Imagens",
		"music": "Música",
		"pdf": "PDF",
		"pressToExecute": "Prima enter para executar.",
		"pressToSearch": "Prima enter para pesquisar.",
		"search": "Pesquise...",
		"searchOrCommand": "Pesquise ou execute um comando...",
		"searchOrSupportedCommand": "Pesquise ou utilize um dos seus comandos:",
		"type": "Escreva e prima enter para pesquisar.",
		"types": "Tipos",
		"video": "Vídeos",
		"writeToSearch": "Escreva aqui para pesquisar"
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrador",
		"allowCommands": "Executar comandos",
		"allowEdit": "Editar, renomear e eliminar ficheiros ou pastas",
		"allowNew": "Criar novos ficheiros e pastas",
		"allowPublish": "Publicar novas páginas e conteúdos",
		"avoidChanges": "(deixe em branco para manter)",
		"changePassword": "Alterar Password",
		"commands": "Comandos",
		"commandsHelp": "Pode definir um conjunto de comandos a executar em determiandos eventos. Deve escrever um comando por linha. Se o evento estiver relacionado com ficheiros, como antes e depois de guardar, irá existir uma variável de ambiente denominada \"FILE\" com o caminho do ficheiro.\n",
		"commandsUpdated": "Comandos atualizados!",
		"customStylesheet": "Estilos Personalizados",
		"examples": "Exemplos",
		"globalSettings": "Configurações Globais",
		"language": "Linguagem",
		"lockPassword": "Não permitir que o utilizador altere a palavra-passe",
		"newPassword": "Nova palavra-passe",
		"newPasswordConfirm": "Confirme a nova palavra-passe",
		"newUser": "Novo Utilizador",
		"password": "Palavra-passe",
		"passwordUpdated": "Palavra-passe atualizada!",
		"permissions": "Permissões",
		"permissionsHelp": "Pode definir o utilizador como administrador ou escolher as permissões manualmente. Se selecionar a opção \"Administrador\", todas as outras opções serão automaticamente selecionadas. A gestão dos utilizadores é um privilégio restringido aos administradores.\n",
		"profileSettings": "Configurações do Utilizador",
		"ruleExample1": "previne o acesso a qualquer \"dotfile\" (como .git, .gitignore) em qualquer pasta\n",
		"ruleExample2": "bloqueia o acesso ao ficheiro chamado Caddyfile.",
		"rules": "Regras",
		"rulesHelp1": "Aqui pode definir um conjunto de regras para permitir ou bloquear o acesso do utilizador a determinados ficheiros ou pastas. Os ficheiros bloqueados não irão aparecer durante a navegação. Suportamos expressões regulares e os caminhos dos ficheiros devem ser relativos à base do utilizador.\n",
		"rulesHelp2": "Cada regra deve ser colocada numa linha diferente e deve começar com as palavras {0} (permite) ou {1} (bloqueia). Deve escrever, logo de seguida, {2}, caso queira utilizar uma expressão regular. Depois, escreva o caminho do ficheiro/pasta ou a expressão regular.\n",
		"scope": "Base",
		"settingsUpdated": "Configurações atualizadas!",
		"user": "Utilizador",
		"userCommands": "Comandos",
		"userCommandsHelp": "Uma lista, separada com espaços, de comandos disponíveis para este utilizados. Exemplo:",
		"userCreated": "Utilizador criado!",
		"userDeleted": "Utilizador eliminado!",
		"userManagement": "Gestão de Utilizadores",
		"username": "Nome de utilizador",
		"users": "Utilizadores",
		"userUpdated": "Utilizador atualizado!"
	},
	"sidebar": {
		"help": "Ajuda",
		"hugoNew": "Hugo New",
		"logout": "Sair",
		"myFiles": "Ficheiros",
		"newFile": "Novo ficheiro",
		"newFolder": "Nova pasta",
		"preview": "Pré-visualizar",
		"settings": "Configurações",
		"siteSettings": "Configurações do Site"
	},
	"time": {
		"unit": "Unidades de Tempo",
		"seconds": "Segundos",
		"minutes": "Minutos",
		"hours": "Horas",
		"days": "Dias"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pt.yaml
// module id = 290
// module chunks = 0